module.exports = __webpack_public_path__ + "../../../../vue-assets/img/logo.43fd0a8e.png";